import { useCallback, useEffect, useState } from 'react';

import { extractTrendUiErrorMessage } from '../errorUtils';
import { fetchTrendSignals } from '../service';
import type { TrendSignal } from '../types';

export function useTrendsSignals() {
  const [signals, setSignals] = useState<TrendSignal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setSignals(await fetchTrendSignals());
    } catch (err: any) {
      setError(extractTrendUiErrorMessage(err, 'Kunde inte ladda trendhistoriken.'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { signals, loading, error, reload };
}
